/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSnapshot } from 'valtio';

import CloseButton from './close_button';
import SwitchRounded from './switch_rounded';

import { layersStore, spacecraftStore, refsStore, kioskStore, eventsStore, poiStore, gmapStore} from '../managers/globalState';

import GearIcon from '../../www/assets/images/gear.svg';

import '../../www/assets/css/settings_menu.css';
import { getOverlay } from './overlays';
import en from '../languages/en';
import ar from '../languages/ar';


const GearMenu = ({ onClose, gearBtnRef }) => {
	const { cityNames, groundTracks, blueMarble } = useSnapshot(layersStore.state);
	const { kioskModeOn } = useSnapshot(kioskStore.state);
	const { showingAllSC } = spacecraftStore.stateSnapshot;

	const { get } = refsStore.stateSnapshot;
	const routeManager = get('route');
	const sceneManager = get('scene');
	const { vitalsign = null, altid = -1 } = routeManager?.query || {};

	const gearMenuRef = useRef(null);

	// Set light fill toggle.
	const cityNamesOnChange = () => {
		layersStore.setGlobalState({ cityNames: !cityNames });
	};

	const groundTracksOnChange = () => {
		layersStore.setGlobalState({ groundTracks: !groundTracks });
	};

	// Only show ground tracks option if a single spacecraft is in view - whether in s/c view or vital sign view
	const showGroundTracksToggle = !showingAllSC;

	// Add the outside click listener on mount and remove it at dismount
	useEffect(() => {
		// Close the menu if we ever click outside of it - ignore if gear icon is clicked, that toggle behavior is handled in SettingsMenu
		const handleOutsideClick = e => {
			const gearIconClicked = gearBtnRef.current.contains(e.target);
			const gearMenuClicked = gearMenuRef.current.contains(e.target);

			if (gearMenuRef && gearMenuRef.current && !gearMenuClicked && !gearIconClicked) {
				if (typeof onClose === 'function') { onClose(); }
			}
		};

		document.addEventListener('click', handleOutsideClick);

		document.documentElement.setAttribute('style', `--customSettingsLeftMargin: ${kioskModeOn ? '193px' : '155px'}`);

		return () => {
			document.removeEventListener('click', handleOutsideClick);
		};
	}, [onClose, gearBtnRef, kioskModeOn]);

	return (

	// {this.language.settings} 	{this.language.city_names}
		<div className='gear-menu' ref={gearMenuRef}>
			<span className='gear-menu-title'>الإعدادات</span>
			<CloseButton size='small' onClick={onClose} />
			<div className='gear-menu-item'>
				<span>{ar.city_names}</span>
				<SwitchRounded checked={cityNames} onChange={cityNamesOnChange} />
			</div>

			{
				vitalsign === 'satellites' && altid === 0
				&& (
					<div className='gear-menu-item'>
						<span>{ar.Cloud_free_Earth}</span>
						<SwitchRounded
							checked={blueMarble} onChange={() => {
								sceneManager.toggleTexture(!blueMarble ? 'bluemarble' : 'wmts');
							}}
						/>
					</div>
				)
			}

			{
				showGroundTracksToggle
				&& (
					<div className='gear-menu-item'>
						<span>{ar.display_ground_tracks}</span>
						<SwitchRounded checked={groundTracks} onChange={groundTracksOnChange} />
					</div>
				)
			}
		</div>
	);
};

GearMenu.propTypes = {
	onClose: PropTypes.func
};


const SettingsMenu = ({ toggleTimeControls }) => {
	const [isOpen, setIsOpen] = useState(false);
	const gearBtnRef = useRef();

	const toggleOpen = () => {
		// if it's not open, it will be and we need to close the time control
		if (!isOpen && typeof toggleTimeControls === 'function') { toggleTimeControls(false); }
		setIsOpen(currIsOpen => !currIsOpen);
	};

	return (
		<>
			<div className='gear-btn' onClick={toggleOpen} ref={gearBtnRef}>
				<GearIcon className={`gear-icon ${isOpen ? 'active' : ''}`} />
			</div>
			{ isOpen && <GearMenu onClose={() => setIsOpen(false)} gearBtnRef={gearBtnRef} /> }
		</>
	);
};

SettingsMenu.propTypes = {
	toggleTimeControls: PropTypes.func
};

export default SettingsMenu;
